import {useIntl} from 'react-intl';
import TicketDisplay from '../Components/TicketDisplay';
import {PageTitle} from '../../../_metronic/layout/core';

const SupportListPage = (): JSX.Element => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.SUPPORT'})}</PageTitle>
      <TicketDisplay />
    </>
  );
};

export default SupportListPage;
